export enum ConnectedServiceType {
  UmojoAnalytics = 1,
  NexCity = 2,
  NexPark = 3,
  NexResponse = 4,
}
